import Box from '@mui/material/Box';
import { useAuthenticated } from 'react-admin';
import NavigationContainer from '@/components/navigation/navigation-container';
import { Outlet } from 'react-router';

const Main = () => {
    useAuthenticated();

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: '300px 1fr',
                gap: 1,
                height: '100%',
            }}
        >
            <NavigationContainer />

            <Outlet />
        </Box>
    );
};

export default Main;
